import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-platform-master-skeleton',
  templateUrl: './platform-master-skeleton.component.html',
  styleUrls: ['./platform-master-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class PlatformMasterSkeletonComponent {
  readonly rows = [1, 2, 3, 4, 5, 6];
}